import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { FormBuilder, Validators } from '@angular/forms';
import { ProfileDetails } from '../../models/profile-details';
import { SessionUser } from 'src/app/shared/models/session-user';
import { AssociateService } from 'src/app/shared/services/associate.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss']
})
export class ProfileCardComponent implements OnInit {
  @Input() edit: boolean = false;
  @Input() saving: boolean = false;
  @Output() valid = new EventEmitter<boolean>(false);
  @Output() newUser = new EventEmitter<ProfileDetails>(false);
  @Input() saveEvent: Observable<boolean> = new Observable<boolean>();

  user: ProfileDetails;
  profilePercent: number;
  profileImage$: Observable<string>;
  destroy$ = new Subject();
  isImageValid: boolean = false;
  isFormValid: boolean = false;

  userEdit = this.fb.group({
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    phone: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    jobTitle: ['']
  });
  today = new Date();
  firstLoad: boolean = true;
  errorState: boolean = false;
  sessionUser$: Observable<SessionUser>;

  constructor(
    private readonly associateService: AssociateService,
    private readonly router: Router,
    private readonly profileImageStore: Store<{ profileImage: string }>,
    private readonly sessionUserStore: Store<{ sessionUser: SessionUser }>,
    private readonly fb: FormBuilder
  ) {
    this.profileImage$ = this.profileImageStore.pipe(select('profileImage'));
    this.sessionUser$ = this.sessionUserStore.pipe(select('sessionUser'));
  }
  async ngOnInit() {
    try {
      this.profileImage$.pipe(takeUntil(this.destroy$)).subscribe(async (url: string) => {
        if (url) {
          this.profilePercent = await this.associateService.getProfilePercent();
        }
      });
      this.sessionUser$.pipe(takeUntil(this.destroy$)).subscribe(async (user) => {
        if (!this.firstLoad) {
          this.profilePercent = await this.associateService.getProfilePercent();
          this.user = await this.associateService.getProfileDetails();
          this.newUser.emit(this.user);
        }
      });
      this.user = await this.associateService.getProfileDetails();
      this.newUser.emit(this.user);
      this.userEdit.controls.firstName.setValue(this.user?.firstName);
      this.userEdit.controls.lastName.setValue(this.user?.lastName);
      this.userEdit.controls.phone.setValue(this.user?.phone);
      this.userEdit.controls.jobTitle.setValue(this.user?.jobTitle);
      this.userEdit.controls.email.setValue(this.user?.email);
      this.isFormValid = this.userEdit.valid;
    } catch (e) {
      this.router.navigateByUrl('/Home');
    }

    this.userEdit.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      this.newUser.emit(user as any);
      this.isFormValid = this.userEdit.valid;
      this.updateValidity();
    });
    this.firstLoad = false;

    this.saveEvent.pipe(takeUntil(this.destroy$)).subscribe((save) => {});
  }

  updateValidity() {
    const isValid = this.isFormValid && this.isImageValid;
    this.valid.emit(isValid);
  }

  onImageValidChange(valid: boolean) {
    this.isImageValid = valid;
    this.updateValidity();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onSearchSize(searchValue: string): void {
    if (searchValue.length <= 2) {
      this.errorState = true;
    } else {
      this.errorState = false;
    }
  }
}
